import React, { useState, useEffect } from "react";
import { CiHeart } from "react-icons/ci";
import axiosConfig from "../Service/axiosConfig";
import { useNavigate, useParams } from "react-router-dom";

const EventGrid = () => {
  const [event, setEvent] = useState([]);
  const navigate = useNavigate();
  // Fetch course data from the API
  useEffect(() => {
    let role = JSON.parse(localStorage.getItem("user_data")).role;
    console.log(role, "r");
    const GetEvents = async () => {
      try {
        const response = await axiosConfig.get(`/accounts/event/`);
        const data = response.data.results;
        console.log(data, "ggg");
        setEvent(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    GetEvents();
  }, []);

  const navigateToCourseDetails = (eventId) => {
    navigate(`/eventinfo/${eventId}`);
  };

  const handleOpenCourse = (Id) => {
    navigate(`/${Id}/editevent`);
  };
  const truncateDescription = (text, maxLength = 150) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  return (
    <>
      {event.length > 0 &&
        event.map((events, index) => (
          <div className="course-card" key={index}>
            <img
              src={
                events.thumbnail?.image ||
                require("../Pages/images/trainer-img1.webp")
              }
              alt={events.thumbnail?.image}
            />
            <div className="course-content">
              <h3>{events.event_title}</h3>
              {events?.event_description && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: truncateDescription(events?.event_description),
                  }}
                />
              )}
              {/* <p>{truncateDescription(events.event_description, 50)}</p> */}
              <div className="course-details">
                <div className="detail">
                  <span className="label">Start Date Time:</span>
                  <span className="label">{events.start_datetime}</span>
                </div>
                <div className="detail">
                  <span className="label">End Date Time:</span>
                  <span className="label">{events.end_datetime}</span>
                </div>
                <div className="detail">
                  <span className="label">Event Duration:</span>
                  <span className="value">{events.event_duration}</span>
                </div>
                <div className="detail">
                  <span className="label">Event Type</span>
                  <span className="value">{events.event_type}</span>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <button
                  className="read-more-btn"
                  onClick={() => navigateToCourseDetails(events.id)}
                >
                  Read More
                </button>
                <button
                  className="action-btn"
                  onClick={() => handleOpenCourse(events.id)}
                >
                  Action
                </button>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default EventGrid;
